import React, { Component } from 'react';
import './../css/signin.css';
import DjangoCSRFToken from './djangocrsf.js';
import aidao from './../assets/images/aidao_outlined_grey.png';
import content from './data/content.js';

export default class ResetPassword extends Component {

  render() {

    var data = content[1]["page"]["resetpassword"];

    return (

    <div id="wrapper">
      <div class="container">
        <div class="fixed-card-box">
            <div class="logo m-t-30 m-b-30">
            <img src={aidao} alt="AiDAO logo"/>
            </div>
                <div class="text-left">
                    <h4 class="header-title m-t-0 m-b-30">{data.sendRecoveryLink}</h4>
                        <form method="post"><DjangoCSRFToken />
                            <div class="form-group">
                                <input id="pass1" name="inputEmail" type="email" placeholder={data.enterEmail} class="form-control" data-parsley-id="8" required />
                            </div>
                            <div class="g-recaptcha distance" data-sitekey="6LcrwD0UAAAAAOvi683E0yW6qkjkrWUZNWRYEWZk"></div>

                            <div class="grey_btn m-b-20 m-t-10">
                              <button type="submit" class="btn btn-block btn-default waves-effect waves-light btn-md p-t-5 p-b-5">{data.send}</button>
                            </div>

                          <div class="forgotpassword">
                            <a href="/" >{data.backtoSignin}</a>
                          </div>
                        </form>
                </div>
          </div>
        </div>
      </div>



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/resetpassword.js